module.exports = __webpack_public_path__ + "static/media/image_70.ec2b5476.png";